import { dateFormat } from 'design-system';
import genderString from './genderString';
import { identificationTypeString } from './identificationTypeString';
import EmissionDataFields from '../models/helperTypes/EmissionDataFields';
import store from '../store';

const { dateFromServerString } = dateFormat;

/** Map used to display in the UI component */
export const displayTextMap: { [key: string]: string } = {
  idType: 'Tipo de identificación',
  email: 'Correo electrónico',
  phoneNumber: 'Celular o teléfono',
  names: 'Nombres',
  lastNames: 'Apellidos',
  birthday: 'Fecha de nacimiento',
  gender: 'Género',
  legalEntityName: 'Nombre de la empresa',
  legalEntityCountry: 'País',
  legalEntityOccupation: 'Actividad económica de la empresa',
};

/** ADT to handle summary data type */
export type NaturalPersonSummaryData = {
  customerType: 'N';
  idType: string;
  email: string;
  phoneNumber: string;
  idNumber: string;
  names: string;
  lastNames: string;
  birthday: string;
  gender: string;
};

export type LegalPersonSummaryData = {
  customerType: 'J';
  idType: string;
  idNumber: string;
  legalEntityName: string;
  phoneNumber: string;
  email: string;
  legalEntityCountry: string;
  legalEntityOccupation: string;
};

export type CustomerSummaryData =
  | NaturalPersonSummaryData
  | LegalPersonSummaryData;

/**
 * Parses out natural/legal person data depending on the
 * customer type parameter.
 */
function parseCustomerSummaryData(
  customerType: 'N' | 'J',
  datataFields: EmissionDataFields,
  isCollective = true,
): CustomerSummaryData {
  const {
    idType,
    email,
    phoneNumber,
    idNumber,
    names,
    lastNames,
    birthday,
    gender,
    legalEntityName,
    legalEntityCountry,
    legalEntityOccupation,
    economicActivity,
    economicActivityName,
    addressCountryName,
  } = datataFields;

  if (customerType === 'N') {
    return {
      customerType,
      names,
      lastNames,
      idType: identificationTypeString(idType),
      idNumber,
      birthday: dateFromServerString(birthday),
      gender: genderString(gender),
      phoneNumber,
      email,
    };
  }

  /** Search for corresponding text values held as catalog codes */
  let country =
    store.getState().legalEntityCatalog.countriesMap[legalEntityCountry] || '';
  let occupation =
    store.getState().legalEntityCatalog.occupationsMap[legalEntityOccupation] ||
    '';
  if (!isCollective) {
    country = addressCountryName;
    occupation =
      economicActivityName ||
      store.getState().legalEntityCatalog.economicActivitiesMap[
        economicActivity
      ] ||
      legalEntityOccupation;
  }

  return {
    customerType,
    idType: identificationTypeString(idType),
    idNumber,
    legalEntityName,
    phoneNumber,
    email,
    legalEntityCountry: country,
    legalEntityOccupation: occupation,
  };
}

export default parseCustomerSummaryData;
